import React from 'react'
import { Header } from '@LTIDashboard/modules/common'
import { Resources } from '@LTIDashboard/modules/GeneralDashboard/Resources'
import { useResourcesValue } from '@LTIDashboard/state'
import {
  LoadingSpinner,
  getLoadingSpinnerProps,
} from '@LTIDashboard/modules/common'

export function ResourcesController() {
  const { resources, status } = useResourcesValue()
  const ResourceComponents = {
    loading: {
      icon: 'neutral',
      Component: LoadingSpinner,
      props: getLoadingSpinnerProps(),
    },
    loaded: { icon: 'ok', Component: Resources, props: { resources } },
  }

  const { icon, Component, props } = ResourceComponents[status]
  return (
    <div className="border rounded card-myed p-3 mt-4">
      <Header title="Resources Paired" status={icon} />
      <Component {...props} />
    </div>
  )
}
